import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotCircleFillMini = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.5253 12.5256C11.3251 13.7258 9.69724 14.4001 7.99985 14.4001C6.30247 14.4001 4.6746 13.7258 3.47437 12.5256C2.27414 11.3253 1.59985 9.69748 1.59985 8.0001C1.59985 6.30271 2.27414 4.67485 3.47437 3.47461C4.6746 2.27438 6.30247 1.6001 7.99985 1.6001C9.69724 1.6001 11.3251 2.27438 12.5253 3.47461C13.7256 4.67485 14.3999 6.30271 14.3999 8.0001C14.3999 9.69748 13.7256 11.3253 12.5253 12.5256ZM7.99992 10.0001C9.10449 10.0001 9.99992 9.10465 9.99992 8.00008C9.99992 6.89551 9.10449 6.00008 7.99992 6.00008C6.89535 6.00008 5.99992 6.89551 5.99992 8.00008C5.99992 9.10465 6.89535 10.0001 7.99992 10.0001Z",
		fill: "currentcolor"
	})]
});
export default SvgDotCircleFillMini;
